export default "__VITE_ASSET__D2QAT9nY__"